import {firebase} from '../config/fbconfig';
const db = firebase.firestore();
class SeatJson{
     static async addSeatJson(seats){
            db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
                    seats: seats
                }, {
                    merge: true
                }).then(async(ref) => {
                    console.log(ref)
                }, (err) => {
                    return err;
                })
    }
    static async addSeatSectionKeys(seats){
        db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).set({
                seatKeys: seats
            }, {
                merge: true
            }).then((ref) => {
                console.log(ref)
            }, (err) => {
                return err;
            })
    }

    static async getSeats() {
        const snapshot = await db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).get()
        return snapshot.docs.map(doc => doc.data());
    }
   
    
    static DeleteData(DataId) {
        return new Promise((resolve, reject) => {
            db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).update({
                eventHex1:'',
                eventHex2:''
            })
            db.collection('chromaUsers').doc(sessionStorage.getItem('MyID')).collection('events').doc(DataId).delete().then(async() => {
                const snapshot = await db.collection('events').get()
                return resolve(snapshot.docs.map(doc => doc.data()));
            }, (err) => {
                return reject(err);
            });
        })

    }

}
export default SeatJson
